/* eslint-disable import/no-named-as-default-member */
import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { AppBar, Tab, Tabs, Toolbar } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import NewDealButton from "../Pipeline/NewDealButton";
import { default as ClosedDealTableColumns } from "../Global/TablePreferenceColumns/DealTableColumns/ClosedDealTableColumns";
import { default as SoldDealViewTableColumns } from "../Global/TablePreferenceColumns/DealTableColumns/SoldDealViewTableColumns";
import DealTable from "../Global/TablePreferenceColumns/DealTable";
import dealStatuses from "../../constants/status";
import TablePaginationHelper from "utils/tablePaginationHelper";

const styles = () => ({
  root: {
    width: "100%"
  },
  tabs: { width: "99%" },
  tabRoot: {
    fontWeight: 400,
    borderBottom: "none",
    minWidth: 100,
    color: "#009DDF"
  },
  tabSelected: {
    fontWeight: "bold",
    borderBottom: "none"
  }
});

class TabButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    };
    this.tablePaginationHelperClosed = new TablePaginationHelper("81dc7e77-e93c-4bec-a088-70e0d0476c46", 25);
    this.tablePaginationHelperSold = new TablePaginationHelper("7a848430-35cc-4874-aa2e-911b662aff37", 25);
  }

  updateClosedPage = closedPage => {
    this.tablePaginationHelperClosed = closedPage;
  };

  updateSoldPage = soldPage => {
    this.tablePaginationHelperSold = soldPage;
  };

  handleChange = (_event, value) => {
    this.setState({ value });
  };

  pathFunction = id => {
    return `/portfolio/funds/free/deals/${id}`;
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <div className={classes.root}>
        <AppBar position="static" color="inherit">
          <Grid container spacing={8} alignItems="center">
            <Toolbar
              style={{
                justifyContent: "flex-start",
                minHeight: "50px",
                width: "100%",
                paddingLeft: 0
              }}
            >
              <Tabs value={value} onChange={this.handleChange} indicatorColor="primary" textColor="primary">
                <Tab
                  key={0}
                  value={0}
                  id="ClosedDealsTab"
                  label="CLOSED DEALS"
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.tabSelected
                  }}
                />
                <Tab
                  key={1}
                  value={1}
                  id="soldDealsTab"
                  label="SOLD DEALS"
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.tabSelected
                  }}
                />
              </Tabs>
              <NewDealButton />
            </Toolbar>
          </Grid>
        </AppBar>
        {value === 0 && (
          <DealTable
            screenType="closed_deal_table"
            TableScreenElements={ClosedDealTableColumns}
            status={[dealStatuses.CLOSED, dealStatuses.REFINANCE, dealStatuses.ADDING_SUPPLEMENTAL, dealStatuses.MODIFYING]}
            fundId={null}
            rowsPerPage={this.tablePaginationHelperClosed.rowsPerPage}
            tableConfigItemId="81dc7e77-e93c-4bec-a088-70e0d0476c46"
            page={this.state.closedPage}
            pathFunction={this.pathFunction}
            updatePage={this.updateClosedPage}
          />
        )}
        {value === 1 && (
          <DealTable
            screenType="sold_deal_table"
            TableScreenElements={SoldDealViewTableColumns}
            status={[dealStatuses.SOLD]}
            fundId={null}
            rowsPerPage={this.tablePaginationHelperSold.rowsPerPage}
            tableConfigItemId="7a848430-35cc-4874-aa2e-911b662aff37"
            page={this.state.soldPage}
            pathFunction={this.pathFunction}
            updatePage={this.updateSoldPage}
          />
        )}
      </div>
    );
  }
}

TabButtons.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(TabButtons);
